import { useEffect } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { enableForEnv, Stages } from "~/lib/utils";

export const HelpScoutScript = () => {
  const { data: user } = useGetCurrentUser();

  const isEnabled = enableForEnv([
    Stages.PRODUCTION,
    Stages.STAGING,
    Stages.DEV,
  ]);

  useEffect(() => {
    if (!isEnabled) return;

    const script = document.createElement("script");
    script.id = "beacon-main-script";
    script.innerHTML = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net/",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;
    document.head.appendChild(script);

    const initScript = document.createElement("script");
    initScript.id = "beacon-init-script";
    initScript.innerHTML = `window.Beacon('init', '0e971a9b-2b9b-4cd9-b394-415c6193d595')`;
    document.head.appendChild(initScript);

    return () => {
      document.querySelector("#beacon-container")?.remove();
      document.querySelector("#beacon-main-script")?.remove();
      document.querySelector("#beacon-init-script")?.remove();
    };
  }, [isEnabled]);

  useEffect(() => {
    if (!user?.email) return;

    const prefillScript = document.createElement("script");
    prefillScript.id = "beacon-prefill-script";
    prefillScript.innerHTML = `window.Beacon('prefill', { email: ${JSON.stringify(user.email)}, name: ${JSON.stringify(user.name)} })`;
    document.head.appendChild(prefillScript);

    return () => {
      document.querySelector("#beacon-prefill-script")?.remove();
    };
  }, [user?.email, user?.name]);

  if (!isEnabled) {
    return null;
  }

  return null;
};
